var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('essential-informations-form',{attrs:{"container-class":"mt-1 mb-2","subscription-plan":_vm.subscriptionPlan,"validation":_vm.validation,"is-disabled":_vm.isDisabled}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }